import React, { useContext, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { useMsal } from '@azure/msal-react';
import {
  ErrorContext,
  ErrorNotFoundPage,
  FullPageLoadingSpinner,
  MainContent,
  MainLayout,
  NoAccessPage,
  ProfileContext,
  setAvatar,
  setErrorMessage,
  setProfileDetails,
  setListOfRoles,
  setSelectedRole,
} from 'csapps-react';
import LandingPage from '../LandingPage';
// import UserManagementPage from '../UserManagementPage';
// import UserManagement from '../UserManagement'; // New user management
// import UserSupportPage from '../UserSupportPage';
// import SystemNotifications from '../Communication/SystemNotifications';
import { ReactComponent as HomeSvg } from './assets/icons/Home.svg';
import { ReactComponent as GroupSvg } from './assets/icons/Group.svg';
import { ReactComponent as ProductLogoSvg } from '../AppMain/assets/digital-platform-logo.svg';
import { platformAppMgtAPI, platformUsrMgtAPI } from '../../api';

// import SupportTicket from '../SupportTicket/SupportTicket';
// import ContactSupport from '../SupportTicket/UserContactSupport';
// import RequestTicket from '../SupportTicket/UserRequestTickets';
// import TicketDetails from '../SupportTicket/TicketDetails';

import { getTokenSilent } from '../../auth';
import { msalInstance } from '../../auth';
import { jwtDecode } from 'jwt-decode';

export default function AppMain() {
  const { instance, accounts } = useMsal();

  const location = useLocation();
  const navigate = useNavigate();
  const errorDispatch = useContext(ErrorContext).dispatch;
  const profileDispatch = useContext(ProfileContext).dispatch;
  const { selectedRole, selectedRoleId } = useContext(ProfileContext).state;
  const [profileData, setProfileData] = useState();
  const [rolesList, setRolesList] = useState();
  const [selectedRoleData, setSelectedRoleData] = useState();
  const [isLandingPage, setIsLandingPage] = useState(true);
  const [isOpenContactSupport, setIsOpenContactSupport] = useState(false);

  const [aadid, setAadid] = useState('');

  React.useEffect(() => {
    getTokenSilent(msalInstance).then((token) => {
      const { oid } = jwtDecode(token);
      setAadid(oid);
    });
  }, []);

  console.log('selectedRole', selectedRole);
  useEffect(() => {
    console.log('Page changed to', location.pathname);
    switch (location.pathname) {
      case '/':
        setIsLandingPage(true);
        break;
      default:
        setIsLandingPage(false);
        break;
    }
  }, [location]);

  useEffect(() => {
    if (selectedRole !== undefined) {
      if (selectedRole !== JSON.parse(sessionStorage.getItem('selectedWDRole'))) {
        sessionStorage.setItem('selectedWDRole', JSON.stringify(selectedRole));
        sessionStorage.setItem('selectedWDRoleId', JSON.stringify(selectedRoleId));
        window.location.reload();
      }
    }
  }, [selectedRole]);

  const commonMenu = [
    {
      name: 'Home',
      icon: <HomeSvg />,
      isActiveRegex: '^/?$',
      route: '/',
    },
  ];

  const adminMenu = [
    {
      name: 'User management',
      icon: <GroupSvg />,
      isActiveRegex: '^/user-management(/.*)?$',
      route: '/user-management',
    },
    {
      name: 'Notifications',
      icon: <span className="material-symbols-outlined">mail</span>,
      children: [
        {
          name: 'System notifications',
          route: '/system-notifications',
          isActiveRegex: '^/system-notifications(/.*)?$',
        },
        {
          name: 'Mass notifications',
          route: '/mass-notifications',
          isActiveRegex: '^/mass-notifications(/.*)?$',
        },
      ],
    },
  ];

  const supportMenu = [
    {
      name: 'Support Tickets',
      icon: <span className="material-symbols-outlined text-xl/[20px]">inbox</span>,
      isActiveRegex: '^/support-ticket(/.*)?$',
      route: '/support-ticket',
    },
  ];

  const menuItems = React.useMemo(() => {
    const role = JSON.parse(sessionStorage.getItem('selectedWDRole'));
    if (role === 'Admin') return [...commonMenu, ...adminMenu];
    if (role === 'Support') return [...commonMenu, ...supportMenu];
    return commonMenu;
  }, [selectedRole]);

  const getRoles = async (productId, userId) => {
    try {
      const { data } = await platformAppMgtAPI.GET(
        `product/${productId}/user_roles?user_id=${userId}`,
      );
      return data;
    } catch (e) {
      console.error(e);
      errorDispatch(setErrorMessage('No roles found'));
    }
  };

  const getProfileImage = async (emailId) => {
    try {
      const { data } = await platformUsrMgtAPI.GET(`/get_user_image?user=${emailId}`);
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getApplicationAccess = async () => {
    try {
      const { data } = await platformUsrMgtAPI.GET(`/application_access?aadid=${aadid}`);
      const {
        Profile: { Id },
      } = data;
      sessionStorage.setItem('profileData', JSON.stringify(data?.Profile));
      const { profileImage } = await getProfileImage(data.Profile?.Email);
      profileDispatch(setAvatar(profileImage, data.Profile.ShortName));
      profileDispatch(setProfileDetails(data.Profile.FirstName, data.Profile.Email));
      setProfileData(data?.Profile);
      const product = data.Profile.Applications.find((p) => p.Name === 'CS');
      if (product !== undefined) {
        const roles = await getRoles(product.Id, Id);
        const selectedRole = JSON.parse(sessionStorage.getItem('selectedWDRole'));
        // Updated the role if not available in session storage
        if (selectedRole === null) {
          sessionStorage.setItem('selectedWDRole', JSON.stringify(roles.default.Name));
          sessionStorage.setItem('selectedWDRoleId', JSON.stringify(roles.default.Id));
        }
        setRolesList(roles);
      } else {
        sessionStorage.setItem('selectedWDRole', 'null');
        sessionStorage.setItem('selectedWDRoleId', 'null');
      }
    } catch (error) {
      errorDispatch(
        setErrorMessage('Failed to fetch profile data. Try to reload to fetch details'),
      );
    }
  };

  useEffect(() => {
    if (aadid !== '') {
      getApplicationAccess(aadid);
    }
  }, [accounts, instance, aadid]);

  useEffect(() => {
    if (rolesList) {
      profileDispatch(
        setSelectedRole(
          JSON.parse(sessionStorage.getItem('selectedWDRole')),
          JSON.parse(sessionStorage.getItem('selectedWDRoleId')),
        ),
      );
      profileDispatch(setListOfRoles(rolesList));
      setSelectedRoleData(rolesList.default);
    }
  }, [rolesList]);

  // Show spinner while profile data is loading
  if (!profileData) {
    return <FullPageLoadingSpinner />;
  }

  const onClickHelpMenuItem = (data) => {
    switch (data) {
      case 'My requests':
        navigate('/support-ticket-request');
        break;
      case 'Contact support':
        setIsOpenContactSupport(true);
        break;
      default:
        return;
    }
  };

  const closeOpenPop = () => {
    setIsOpenContactSupport(false);
  };

  const helpMenuItems = [
    {
      icon: <span className="material-symbols-outlined text-base">history</span>,
      label: 'My requests',
    },
    {
      icon: <span className="material-symbols-outlined text-base">forum</span>,
      label: 'Contact support',
    },
  ];

  return (
    <MainLayout
      // isSideBar={isLandingPage} // Enable this if you want to hide the sidebar in landing page
      isSideBar={false}
      menuItems={menuItems}
      footerMenuItems={[]}
      headerHelpItems={[]}
      // headerMenuItems={selectedRole !== undefined ? headerMenuItems : []}
      headerContent={<ProductLogoSvg />}
      onViewAccount={() => {
        window.open('https://myaccount.microsoft.com/', '_blank').focus();
      }}
      onLogout={() => {
        localStorage.clear();
        sessionStorage.clear();
        instance.logoutRedirect().catch((e) => {
          console.error(e);
        });
      }}
      onClickHelpMenuItem={onClickHelpMenuItem}
    >
      <MainContent
        className={`${isLandingPage ? 'bg-cover bg-bottom p-0' : ''} `}
        style={{ backgroundImage: "url('/assets/Home-page-background.jpg')" }}
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* {selectedRole !== undefined && <Route path="/support" element={<UserSupportPage />} />} */}
          {JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Admin' && (
            <>
              {/* <Route path="/user-management" element={<UserManagementPage />} /> */}

              {/* <Route path="/system-notifications/" element={<SystemNotifications />} /> */}
              {/* <Route path="/mass-notifications/" element={<MassNotification />} /> */}
              {/* <Route path="/mass-notifications/send-notification" element={<SendNotification />} /> */}
              {/* <Route */}
              {/* path="/mass-notifications/send-notification/:notificationId" */}
              {/* element={<SendNotification />} */}
              {/* /> */}
              {/* <Route path="/mass-notifications/:notificationId" element={<ViewNotification />} /> */}
              {/* <Route */}
              {/* path="/system-notifications/notification-overview/:title" */}
              {/* element={<NotificationTemplate />} */}
              {/* /> */}
            </>
          )}
          {/*<Route path="/user-management" element={<UserManagementPage />} />*/}

          {/* {JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Support' ||
          JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Admin' ? (
            <>
              <Route path="/support-ticket-request" element={<RequestTicket />} />
              <Route path="/support-ticket/:ticketId" element={<TicketDetails />} />
              <Route path="/support-ticket-request/:ticketId" element={<TicketDetails />} />
            </>
          ) : (
            ''
          )}
          {JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Support' && (
            <Route path="/support-ticket" element={<SupportTicket />} />
          )} */}
          <Route path="*" element={<ErrorNotFoundPage />} />
        </Routes>
        {/* {(JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Support' ||
          JSON.parse(sessionStorage.getItem('selectedWDRole')) === 'Admin') && (
          <ContactSupport open={isOpenContactSupport} handleFormClose={closeOpenPop} />
        )} */}
      </MainContent>
    </MainLayout>
  );
}
